(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var eventProperties = {};
        eventProperties['Page'] = 'new_hotel_view_page';

        var getButton = function getButton() {
            return document.querySelector('.js-show-tours-link');
        };

        var getDepartCities = function getDepartCities() {
            return window.app && Array.isArray(window.app.departCities) ? window.app.departCities : [];
        };

        var getDirectionDepartCities = function getDirectionDepartCities() {
            return window.app && Array.isArray(window.app.directionDepartCities) ? window.app.directionDepartCities : [];
        };

        var findDepartCity = function findDepartCity(cityId, cities) {
            if (!cityId || !Array.isArray(cities)) {
                return null;
            }

            return cities.find(function (item) {
                return String(item && item.id) === String(cityId);
            }) || null;
        };

        var getDefaultDepartCity = function getDefaultDepartCity() {
            if (window.app && window.app.defaultDepartCity) {
                return window.app.defaultDepartCity;
            }

            return null;
        };

        var getModalMountNode = function getModalMountNode(button) {
            var modalContentId = button.dataset.modalContentId;
            if (!modalContentId) {
                return null;
            }

            var mountNodeId = modalContentId + '-mount';
            var mountNode = document.getElementById(mountNodeId);

            if (!mountNode) {
                mountNode = document.createElement('div');
                mountNode.id = mountNodeId;
                mountNode.hidden = true;
                document.body.appendChild(mountNode);
            }

            return mountNode;
        };

        var getButtonState = function getButtonState(button) {
            var baseLabel = button.dataset.baseLabel || 'Показать туры';
            if (button.dataset.hotelsSearch === '1') {
                return { baseLabel: baseLabel, label: baseLabel, cityId: '', shouldChooseCity: false, shouldUseDefaultRouting: false };
            }
            var selectedCityId = button.dataset.selectedCityId || '';
            var directionDepartCities = getDirectionDepartCities();
            var hasDirectionDepartCities = directionDepartCities.length > 0;
            var hasSingleDirectionDepartCity = directionDepartCities.length === 1;
            var selectedCity = findDepartCity(selectedCityId, hasDirectionDepartCities ? directionDepartCities : getDepartCities());
            var defaultDepartCity = getDefaultDepartCity();

            if (selectedCity) {
                return {
                    baseLabel: baseLabel,
                    label: baseLabel + ' из ' + (selectedCity.nameGenitive || selectedCity.name),
                    cityId: String(selectedCity.id),
                    shouldChooseCity: false,
                    shouldUseDefaultRouting: false
                };
            }

            if (hasSingleDirectionDepartCity) {
                var singleDirectionDepartCity = directionDepartCities[0];

                return {
                    baseLabel: baseLabel,
                    label: baseLabel + ' из ' + (singleDirectionDepartCity.nameGenitive || singleDirectionDepartCity.name),
                    cityId: String(singleDirectionDepartCity.id),
                    shouldChooseCity: false,
                    shouldUseDefaultRouting: false
                };
            }

            if (hasDirectionDepartCities) {
                return {
                    baseLabel: baseLabel,
                    label: baseLabel,
                    cityId: '',
                    shouldChooseCity: true,
                    shouldUseDefaultRouting: false
                };
            }

            if (defaultDepartCity) {
                return {
                    baseLabel: baseLabel,
                    label: baseLabel + ' из ' + (defaultDepartCity.nameGenitive || defaultDepartCity.name),
                    cityId: '',
                    shouldChooseCity: false,
                    shouldUseDefaultRouting: true
                };
            }

            return {
                baseLabel: baseLabel,
                label: baseLabel,
                cityId: '',
                shouldChooseCity: false,
                shouldUseDefaultRouting: true
            };
        };

        var renderShowToursButton = function renderShowToursButton() {
            var button = getButton();
            if (!button) {
                return;
            }

            var state = getButtonState(button);
            button.dataset.computedCityId = state.cityId;
            button.dataset.shouldChooseCity = state.shouldChooseCity ? '1' : '0';
            button.dataset.shouldUseDefaultRouting = state.shouldUseDefaultRouting ? '1' : '0';
            button.textContent = state.label;

            if (state.shouldChooseCity) {
                var mountNode = getModalMountNode(button);
                var modalNode = document.getElementById(button.dataset.modalContentId);

                if (!mountNode) {
                    return;
                }

                if (!modalNode) {
                    modalNode = document.createElement('div');
                    modalNode.id = button.dataset.modalContentId;
                    modalNode.className = 'show-tours-city-modal-content';
                    mountNode.appendChild(modalNode);
                } else if (modalNode.parentNode !== mountNode) {
                    mountNode.appendChild(modalNode);
                }

                modalNode.innerHTML = "\n            <div class=\"show-tours-city-modal-content__list\">\n                " + getDirectionDepartCities().map(function (city) {
                    return "\n                    <button\n                        type=\"button\"\n                        class=\"show-tours-city-modal-content__option js-show-tours-city-option\"\n                        data-city-id=\"" + city.id + "\"\n                    >\n                        " + city.name + "\n                    </button>\n                ";
                }).join('') + "\n            </div>\n        ";
            }
        };

        var persistDepartCity = function persistDepartCity(cityId) {
            if (!cityId) {
                return;
            }

            var expires = new Date();
            expires.setDate(expires.getDate() + 365);
            document.cookie = 'find_form_city_id=' + cityId + '; expires=' + expires.toUTCString() + '; path=/';
        };

        var buildShowToursUrl = function buildShowToursUrl(button, cityId) {
            var url = button.dataset.url || '';
            var params = new URLSearchParams(button.dataset.params || '');

            if (button.dataset.hotelsSearch === '1') {
                params.delete('departCity');
                params.delete('departCityId');
                params.set('hotelsSearch', '1');
            } else if (cityId) {
                params.set('departCity', cityId);
                params.set('departCityId', cityId);
            }

            var query = params.toString();
            return url + (query ? '?' + query : '');
        };

        var navigateToTours = function navigateToTours(button, cityId) {
            window.brxTracking.sendAnalyticsEvent('click_show_tours', eventProperties);

            if (cityId) {
                persistDepartCity(cityId);
            }

            if (window.showPageLoader) {
                window.showPageLoader();
            }

            if (button.dataset.shouldUseDefaultRouting === '1' && !cityId) {
                var url = button.dataset.url || '';
                var params = button.dataset.params || '';
                window.location.href = url + (params ? '?' + params : '');
                return;
            }

            window.location.href = buildShowToursUrl(button, cityId);
        };

        var openShowToursCityModal = function openShowToursCityModal(button) {
            var modalContentId = button.dataset.modalContentId;
            if (!modalContentId || !window.modal) {
                return;
            }

            window.modal.open({
                header: {
                    title: 'Выберите город вылета'
                },
                content: {
                    htmlDetachSelectorId: modalContentId
                },
                parentCssClass: 'show-tours-city-modal',
                footer: false,
                type: 'bottom'
            });
        };

        document.addEventListener('DOMContentLoaded', function () {
            renderShowToursButton();
        });

        eventDispatcher.on('click', '.js-tg-subscribe-banner', function () {
            window.brxTracking.sendAnalyticsEvent('subscribe_hot_tour', eventProperties);
        });

        eventDispatcher.on('click', '.js-toggle-map-modal', function (e) {
            window.brxTracking.sendAnalyticsEvent('click_map_hotel_page_open', eventProperties);
        });

        eventDispatcher.on('click', '.js-open-hotel-description', function (e) {
            window.brxTracking.sendAnalyticsEvent('click_more_details_about_hotel', eventProperties);
        });

        eventDispatcher.on('click', '.js-open-hotel-includes-list', function (e) {
            window.brxTracking.sendAnalyticsEvent('click_more_what_includes_in_tour', eventProperties);
        });

        eventDispatcher.on('click', '.js-show-tours-link', function (e) {
            e.preventDefault();

            var target = e.target.closest('.js-show-tours-link');
            if (!target) {
                return;
            }

            if (target.dataset.hotelsSearch === '1') {
                navigateToTours(target, '');
                return;
            }

            if (target.dataset.shouldChooseCity === '1') {
                openShowToursCityModal(target);
                return;
            }

            navigateToTours(target, target.dataset.computedCityId || '');
        });

        eventDispatcher.on('click', '.js-show-tours-city-option', function (e) {
            e.preventDefault();

            var target = e.target.closest('.js-show-tours-city-option');
            var button = document.querySelector('.js-show-tours-link');

            if (!target || !button) {
                return;
            }

            var cityId = target.dataset.cityId;
            if (!cityId) {
                return;
            }

            if (window.modal) {
                window.modal.close('.modal2');
            }

            navigateToTours(button, cityId);
        });

        eventDispatcher.on('click', '.js-offer-of-day-card', function (e) {
            if (e.target.closest('.offer-of-day-card-link-btn')) {
                return;
            }

            var card = e.target.closest('.js-offer-of-day-card');
            if (!card || !card.dataset.url) {
                return;
            }

            if (window.showPageLoader) {
                window.showPageLoader();
            }

            window.location.href = card.dataset.url;
        });

        eventDispatcher.on('click', '.hotel__rating-block', function (e) {
            var target = document.querySelector('.hotel-reviews-withs-tags-block');
            var header = document.querySelector('.nav-bar');

            if (target) {
                var offset = header ? header.offsetHeight : 65;

                var top = target.getBoundingClientRect().top + window.scrollY - offset;

                window.scrollTo({
                    top: top,
                    behavior: 'smooth'
                });
            }
        });
    }, {}] }, {}, [1]);